'use client'

import React from 'react'
import { LogOut } from 'lucide-react'
import { signOut } from 'next-auth/react'
import { cn } from '@/lib/utils'

import { Button, ButtonProps } from '@/components/ui'
import Loader from '@/app/loading'

export const SignOutButton = ({ className, ...restProps }: ButtonProps) => {
  const [showLoading, setShowLoading] = React.useState(false)

  return (
    <>
      <Button
        variant="secondary"
        size="lg"
        onClick={async () => {
          setShowLoading(true)
          await signOut()
        }}
        className={cn('gap-1', className)}
        {...restProps}
      >
        <LogOut className="-ml-2 size-5" />
        Logout
      </Button>

      {showLoading && (
        <div className="fixed inset-0 z-50 bg-white">
          <Loader />
        </div>
      )}
    </>
  )
}
